document.addEventListener('DOMContentLoaded', () => {

	// Show answer when click question (Legal questions)
 	function questions(e) {
 		let qa = this.innerHTML;
 		let an = ne(this);
 		an = an.innerHTML;
 		let el= $('.modal.questions');
		let el_q = $s(el,'._1');
		let el_a = $s(el,'._2');
		console.log(el_q + " -" + el_a);
 		el_q.innerHTML = qa;
 		el_a.innerHTML = an;
  	}

	$e('.question.modal-trigger', questions,['click']);
	// END
	
	function animate_height(element, start, end, duration,direction) {
  		var elem = element
  		var height = start;
  		var id = setInterval(frame, duration);
 		function frame() {
  			if (height == end) {
	      		clearInterval(id);
	    	} else {
	    		direction === 'plus' ?  height++ : height--;
	      	elem.style.height = height + 'px'; 
	    	}
  		}
	}
});
